import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=ec7901dc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec7901dc')) {
      api.createRecord('ec7901dc', component.options)
    } else {
      api.reload('ec7901dc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=ec7901dc&", function () {
      api.rerender('ec7901dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ClVeeerS0W6F/JS/comp/ImgFallback.vue"
export default component.exports